export const isCustomerWebViewEnabled = (state) => state.customer.webViewEnabled || false;